import React from "react";
import { Typography } from "@mui/material";

export function RegulatoryTextNotCalculatedYet() {
  return (
    <Typography fontSize="0.875rem">
      Les seuils réglementaires seront calculés une fois la mission validée.
    </Typography>
  );
}
